import { useTranslation, Trans } from 'react-i18next';
import LegalPageLayout from '@/components/legal/LegalPageLayout';

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <LegalPageLayout
      title={t('privacy.title')}
      lastUpdated={t('privacy.lastUpdated')}
    >
      <section>
        <p className="lead text-lg text-gray-700 mb-8">
          {t('privacy.intro')}
        </p>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.dataController.title')}</h2>
        <p>{t('privacy.sections.dataController.content')}</p>
        <p className="mt-2">
          <Trans i18nKey="privacy.sections.dataController.contact">
            Contact: <a href="mailto:privacy@mypink.contact">privacy@mypink.contact</a>
          </Trans>
        </p>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.dataCollected.title')}</h2>
        <p>{t('privacy.sections.dataCollected.intro')}</p>
        <ul>
          <li>{t('privacy.sections.dataCollected.items.profile')}</li>
          <li>{t('privacy.sections.dataCollected.items.contact')}</li>
          <li>{t('privacy.sections.dataCollected.items.photo')}</li>
          <li>{t('privacy.sections.dataCollected.items.usage')}</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.purpose.title')}</h2>
        <p>{t('privacy.sections.purpose.intro')}</p>
        <ul>
          <li>{t('privacy.sections.purpose.items.service')}</li>
          <li>{t('privacy.sections.purpose.items.qrCode')}</li>
          <li>{t('privacy.sections.purpose.items.vcard')}</li>
          <li>{t('privacy.sections.purpose.items.improvement')}</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.legalBasis.title')}</h2>
        <p>{t('privacy.sections.legalBasis.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.dataSharing.title')}</h2>
        <p>{t('privacy.sections.dataSharing.content')}</p>
        <ul>
          <li>{t('privacy.sections.dataSharing.items.aws')}</li>
          <li>{t('privacy.sections.dataSharing.items.cognito')}</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.retention.title')}</h2>
        <p>{t('privacy.sections.retention.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.rights.title')}</h2>
        <p>{t('privacy.sections.rights.intro')}</p>
        <ul>
          <li>{t('privacy.sections.rights.items.access')}</li>
          <li>{t('privacy.sections.rights.items.rectification')}</li>
          <li>{t('privacy.sections.rights.items.erasure')}</li>
          <li>{t('privacy.sections.rights.items.portability')}</li>
          <li>{t('privacy.sections.rights.items.objection')}</li>
        </ul>
        <p className="mt-4">
          <Trans i18nKey="privacy.sections.rights.contact">
            To exercise these rights, contact us at <a href="mailto:privacy@mypink.contact">privacy@mypink.contact</a>
          </Trans>
        </p>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.cookies.title')}</h2>
        <p>{t('privacy.sections.cookies.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('privacy.sections.security.title')}</h2>
        <p>{t('privacy.sections.security.content')}</p>
      </section>

      <section>
        <h2>{t('privacy.sections.changes.title')}</h2>
        <p>{t('privacy.sections.changes.content')}</p>
      </section>
    </LegalPageLayout>
  );
}
